import { Provider as RollbarProvider } from "@rollbar/react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import Rollbar from "rollbar";

import App from "./App.jsx";
import ErrorBoundary from "./ErrorBoundary.jsx";
import store from "./store.jsx";

// Define environments where Rollbar is enabled
const environments = ["development", "staging", "production"];
const isEnabledEnvironment = environments.includes(
  import.meta.env.VITE_APP_ENV,
);

// Rollbar configuration
const rollbarConfig = {
  accessToken: import.meta.env.VITE_APP_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  autoInstrument: true,
  enabled: isEnabledEnvironment,
  payload: {
    environment: import.meta.env.VITE_APP_ENV,
    client: {
      javascript: {
        code_version: "1.0.0",
        host: import.meta.env.VITE_APP_SERVER_URL,
        source_map_enabled: true,
      },
    },
  },
};

const rollbar = new Rollbar(rollbarConfig);

createRoot(document.getElementById("root")).render(
  <RollbarProvider config={rollbarConfig}>
    <Provider store={store}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </Provider>
  </RollbarProvider>,
);
